import { render } from "./AiSinkronisasi.vue?vue&type=template&id=13bbcdd1"
import script from "./AiSinkronisasi.vue?vue&type=script&lang=js"
export * from "./AiSinkronisasi.vue?vue&type=script&lang=js"

import "./AiSinkronisasi.vue?vue&type=style&index=0&id=13bbcdd1&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__